import { CpProvincia } from "./cp-provincia";
import { Respuesta } from "./Respuesta";

export class CpProvinciaResult {

    public miRespuesta: Respuesta = new Respuesta();
    public miListCP_Provincia: CpProvincia[] = [];

}
